// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"278b7306","509":"862e2089"}[chunkId] + ".chunk.js";
};